module.exports = "/assets/fa2f86fc6193fbb2b1700b4782a8960e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/trip-item-bus/assets/bus.png
// module id = 3448
// module chunks = 0